import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import type { SelectAllBannerState } from "./SiteSelection";
import type { JSX } from "react";

interface SelectAllBannerProps {
  state: SelectAllBannerState;
  onSelectAllFiltered: () => void;
  onClearSelection: () => void;
}

export function SelectAllBanner(props: SelectAllBannerProps) {
  let selectAllBanner: JSX.Element | null;
  const { state, onSelectAllFiltered, onClearSelection } = props;
  if (state.kind === "hidden") {
    selectAllBanner = null;
  } else {
    if (state.kind === "pageSelected") {
      selectAllBanner = (
      <Alert
        severity="info"
        sx={{ mb: 1 }}
        action={
          <Button color="inherit" size="small" onClick={onSelectAllFiltered}>
            Выбрать все {state.totalCount} записей
          </Button>
        }
      >
        Выбраны все записи на этой странице ({state.pageCount})
      </Alert>
    );
    } else {
      selectAllBanner = (
    <Alert
      severity="info"
      sx={{ mb: 1 }}
      action={
        <Button color="inherit" size="small" onClick={onClearSelection}>
          Снять выделение
        </Button>
      }
    >
      Выбраны все {state.totalCount} записей
    </Alert>
  );
    }
  }
  return selectAllBanner;
}
